import React, {Component} from 'react'
import MybetRow from './MybetRow'


export default class MybetsTable extends Component {
	constructor(props) {
		super(props)
		this.columns = [
			{text: 'Start', key: 'startTime', className: 'col-md-2', sortable:true},
			{text: 'Match', key: 'match', className:'col-md-3'},
			{text: 'Type', key:'oddsType', className:'col-md-2'},
			{text: 'Bookmaker', key:'bookmaker', className:'col-md-1'},
			{text: 'Odds / current', key:'odds', className:'col-md-2', sortable:true},
			{text: 'Stake', key:'wager', className: 'col-md-1', sortable:true},
			{text: 'Return', key:'betReturn', className:'col-md-1', sortable:true},
			{text: 'Status', key: 'status', sortable: true}
		]
	}

	sortBets(bets) {
		let multiplier = this.state.sortedDescending ? 1 : -1
		return bets.sort((a, b) => {
			let sorted = (this.getSortedProp(b) - this.getSortedProp(a)) * multiplier
			if (sorted === 0)
				return a.id - b.id
			return sorted
		})
	}

	render() {
		return (
			<table className='table table-hover table-responsive'>
				<thead>
					<tr>
						{this.columns.map(col => {
							let className
							let handleClick = null
							if (col.sortable) {
								handleClick = this.props.handleClickHeader.bind(this, col.key)
								if (col.key === this.props.sortedColumn) {
									if (this.props.sortedDescending)
										className = 'text-success text-bold'
									else className='text-danger text-bold'
								}
							}
							return (
								<th
									className={col.className + (!!className ? ' ' + className : '' )}
									key={col.key}
									onClick={handleClick}>
									{ col.text }
								</th>
							)
						})}
					</tr>
				</thead>
				<tbody>
					{ this.props.userbets.map(bet => <MybetRow key={bet.id} {...bet} onClick={this.props.onClickRow}/> )}
				</tbody>

			</table>
		)

	}
}



/** WEBPACK FOOTER **
 ** ./src/components/mybets/MybetsTable.js
 **/